"use strict";

exports.__esModule = true;
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

exports.default = isEvent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/events/isEvent.js
 ** module id = 439
 ** module chunks = 0
 **/